export class AdminPortalModel {
  public showCredentialTab: boolean;
  public dashboardTabLabel: string;
  public credentialTabLabel: string;
  public showProfileTab: boolean;
  public profileTabLabel: string;
  public validateProfileAddress: boolean;
  public dashboardPanels: Array<AdminPortalDashboardPanelModel> = [];
  public credentialGroups: Array<AdminPortalCredentialGroupModel> = [];
  public profilePanels: Array<AdminPortalProfilePanelModel> = [];
  public allowUserPdfDownload: boolean;
  public loginMessage: string = null;
  public teamsConfiguration: AdminPortalTeamsConfigurationModel =
    new AdminPortalTeamsConfigurationModel();
}

export class AdminPortalTeamsConfigurationModel {
  public showTeamsTab = false;
  public teamsTabLabel = 'Teams';
  public oDataFilters: string[] = [];
  public oDataQuery: string = null;
  public columns: Array<AdminPortalTeamColumnModel> = [];
}

export class AdminPortalTeamColumnModel {
  public id: string;
  public columnType: PortalTeamColumnType;
  public standardField?: PortalTeamStandardField;
  public customFieldDefinitionId?: string;
  public label?: string;
  public displayName?: string;
}

export enum PortalTeamColumnType {
  StandardField = 'StandardField',
  TeamField = 'TeamField',
  SeatField = 'SeatField'
}

export enum PortalTeamStandardField {
  TeamName = 'TeamName',
  PositionTitle = 'PositionTitle',
  TeamStartDate = 'TeamStartDate',
  TeamEndDate = 'TeamEndDate',
  SeatStartDate = 'SeatStartDate',
  SeatEndDate = 'SeatEndDate',
  SeatStatus = 'SeatStatus'
}

export const PORTAL_TEAM_STANDARD_FIELD_LABELS: Record<PortalTeamStandardField, string> = {
  [PortalTeamStandardField.TeamName]: 'Team Name',
  [PortalTeamStandardField.PositionTitle]: 'Position',
  [PortalTeamStandardField.TeamStartDate]: 'Team Start Date',
  [PortalTeamStandardField.TeamEndDate]: 'Team End Date',
  [PortalTeamStandardField.SeatStartDate]: 'Seat Start Date',
  [PortalTeamStandardField.SeatEndDate]: 'Seat End Date',
  [PortalTeamStandardField.SeatStatus]: 'Status'
};

export class AdminPortalDashboardPanelModel {
  public id: string;
  public panelName: string;
  public description: string;
  public type: DashboardCallToActionType;
  public visibility: DashboardCallToActionVisibility;
  public buttonText: string;
  public buttonActionValue: string;
  public oDataFilters: string[] = [];
  public oDataQuery: string = null;
}

export class AdminPortalCredentialGroupModel {
  public id: string;
  public groupName: string;
  public credentialCount: number;
  public credentialDefinitions: Array<AdminPortalCredentialDefinitionModel> = [];
}

export class AdminPortalProfilePanelModel {
  public id: string;
  public panelName: string;
  public panelLocation: string;
  public panelType: ProfilePanelType;
  public fieldCount: number;
  public profilePageFields: Array<AdminPortalProfileFieldModel> = [];
}

export class AdminPortalCredentialDefinitionModel {
  public id: string;
  public name: string;
}

export class AdminPortalProfileFieldModel {
  public id: string;
  public customFieldDefinitionId: string;
  public fieldType: ProfileFieldType;
  public readOnly: boolean;
  public displayName: string;
}

export enum ProfilePanelType {
  PersonFields = 'PersonFields',
  Certifications = 'Certifications',
  Skills = 'Skills'
}

export enum ProfileFieldType {
  FullName = 'FullName',
  Email = 'Email',
  Phone = 'Phone',
  Address = 'Address',
  JobTitle = 'JobTitle',
  Company = 'Company',
  LinkedInProfile = 'LinkedInProfile',
  CustomField = 'CustomField',
  Skill = 'Skill'
}

export enum DashboardCallToActionType {
  None = 'None',
  LinkToURL = 'LinkToURL',
  LinkToForm = 'LinkToForm'
}

export enum DashboardCallToActionVisibility {
  AllUsers = 'AllUsers',
  Conditional = 'Conditional'
}
